export default function ({ $auth, $gtm }) {
    if ($auth && $auth.user && $auth.user.id) {
        $gtm.push({
            event: 'authentication',
            user_id: $auth.user.id + ''
        })
    }
}
